// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1zkhYuYvrNbIhc {\n  padding: 0 0 0 8px;\n  margin: 0;\n  background: none;\n  font-size: 16px;\n  line-height: 32px;\n  font-weight: 500;\n  min-width: 76px;\n  text-align: center;\n}\n._1zkhYuYvrNbIhc:hover,\n._1zkhYuYvrNbIhc:active {\n  background: none;\n  color: inherit;\n}\n._2q507i04PT-W1M {\n  margin-right: 4px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dateButton": "_1zkhYuYvrNbIhc",
	"dateText": "_2q507i04PT-W1M"
};
export default ___CSS_LOADER_EXPORT___;
